import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useFormik } from 'formik';

import { translatedMessage } from '../../service/LanguageService';

import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { CompetitionService } from '../../service/CompetitionService';
import GeneralUtils from '../../utilities/GeneralUtils';

const defaulNewValue = {
    id: null,
    isced: null,
    domain: null,
    domainName: '',
}

const CompetitionEducationEditDialog = (props) => {
    const [education, setEducation] = useState({});
    const [domains, setDomains] = useState([]);
    const [filteredDomains, setFilteredDomains] = useState([]);
    const [iscedDomains, setIscedDomains] = useState([]);
    const [isDomainDisabled, setIsDomainDisabled] = useState(true);
    const [isDomainNameDisabled, setIsDomainNameDisabled] = useState(false);
    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        // console.log("props: ", props)        
        let _education = props.education ? props.education : { ...defaulNewValue, competition: { id: props?.competition?.id} }
        let _iscedTypes = props?.iscedTypes
        setDomains(props?.domains)

        if(_education?.id) {
            let _isced = _iscedTypes.filter(item => item.value === _education?.isced?.id)
            _education = { ..._education, isced: _isced[0] ? _isced[0] : null }

            handleIscedChange({ value: _education.isced?.value }, false, props?.domains)
            if (_education.domain) {
                handleDomainChange({ value: _education.domain }, false)
            }

            let _domain = {}
            if (_education.domain?.id) {
                _domain = props?.domains.filter(item => item.value === _education.domain.id)
            } else if (_education.domainName && (_isced[0]?.code.toLowerCase() === 'isced6' || _isced[0]?.code.toLowerCase() === 'isced7')) {
                _domain = props?.domains.filter(item => item.value === -1)
            }

            _education = { ..._education, domain: _domain[0] ? _domain[0] : _domain.domain }
        }

        setEducation(_education);
        

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    // Form
    const formik = useFormik({
        initialValues: education,
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};

            // console.log("validate: ", data)
            
            if (!data.isced || !data.isced?.value) {
                errors.isced = translatedMessage("form.error.education.isced.required");
            }

            // if (data.isced) {
            //     let isced = props?.iscedTypes.filter(item => item.value === data.iscedId)
            //     if (isced && isced[0] && (isced[0].code.toLowerCase() === 'isced6' || isced[0].code.toLowerCase() === 'isced7')) {
            //         if (!data.domain) {
            //             errors.domainId = translatedMessage("form.error.education.domain.required");
            //         } else {
            //             if (data.domain?.value === -1 && (!data.domainName || !data.domainName.trim())) {
            //                 errors.domainName = translatedMessage("form.error.education.domainName.required")
            //             }
            //         }
            //     }
            // }

            return errors;
        },
        onSubmit: (data) => {
            let _data = { ...GeneralUtils.nullIfEmptyForObjectFields(data) };
            _data.isced = { id: data.isced.value }
            _data.domain = data.domain ? { id: data.domain.value } : null
            _data.competition = { id: data.competition.id }

            // console.log("saved data: ", _data)

            competitionService.saveCompetitionEducation(_data)
                .then(savedEducation => {
                    if (typeof props.afterSave === 'function') {
                        props.afterSave(savedEducation, true);
                    }
                    handleDialogClose()
                })
                .catch(error => {
                    if (typeof props.afterSave === 'function') {
                        props.afterSave(null, false, error);
                    }
                });
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    const dialogFooter = (
        <>
            <Button label={translatedMessage("generic.cancel")} icon="pi pi-times" className="p-button-text" onClick={() => handleDialogClose()} />
            <Button label={translatedMessage("generic.save")} icon="pi pi-check" className="p-button-text" form="education-form" type="submit" />
        </>
    )

    // Actions
    const resertLookups = () => {
        setIsDomainDisabled(true)
        setFilteredDomains([])
        setIscedDomains([])
    }

    const handleDialogClose = () => {
        props.onClose()
        formik.resetForm()
        resertLookups()
    }

    const handleIscedChange = (data, resetValues = true, _domains = []) => {
        // console.log("handleIscedChange: ", data.value)
        let _domainName = ''

        let _isced = props?.iscedTypes.filter(item => item.value === data.value)
        formik.setFieldValue("isced", _isced[0] ? _isced[0] : {})

        // FIXME: skip domains until they give us the exact noms to implement
        // let _iscedDomains = []
        // if (_isced && _isced[0] && _isced[0].code.toLowerCase() === 'isced6') {
        //     let _domainItems = domains.length > 0 ? domains : _domains;
        //     _iscedDomains = _domainItems.filter(item => (item.relatedId && item.relatedId === _isced[0].value) || item.relatedId === null)

        //     setIscedDomains(_iscedDomains);
        //     setIsDomainDisabled(false)
        // } else {
        //     setIsDomainDisabled(true)
        //     if (_isced && _isced[0] && _isced[0].code.toLowerCase() === 'isced7') {
        //         setIsDomainNameDisabled(true)
        //         _domainName = translatedMessage("competition.education.isced7.domain")
        //     } else {
        //         setIsDomainNameDisabled(false)
        //     }            
        // }

        if (_isced && _isced[0] && _isced[0].code.toLowerCase() === 'isced7') {
            setIsDomainNameDisabled(true)
            _domainName = translatedMessage("competition.education.isced7.domain")
        } else {
            setIsDomainNameDisabled(false)
        }            


        if (resetValues) {
            formik.setFieldValue("domain", null)
            formik.setFieldValue("domainName", _domainName)
        }
    }

    const handleDomainChange = (data, resetValues = true) => {
        // console.log("handleDomainChange")
        formik.setFieldValue("domain", data.value)

        if (resetValues) {
            formik.setFieldValue("domainName", '')
        }
    }

    const searchDomainItems = (event) => {
        // console.log("searchDomainItems")
        let query = event.query;
        let _filteredItems = [];

        for (let i = 0; i < iscedDomains.length; i++) {
            let item = iscedDomains[i];
            if (item.label.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                _filteredItems.push(item);
            }
        }

        setFilteredDomains(_filteredItems);
    }

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={props.visible}
                closable={true}
                onHide={handleDialogClose}
                header={translatedMessage("profile.education.dialog.title")}
                modal
                className="pcn-dialog p-fluid"
                footer={dialogFooter}
            >
                <form id="education-form" onSubmit={formik.handleSubmit}>
                    <div className="input-panel flex flex-column mb-5">                    
                        <div className="p-inputgroup mt-3">
                            <span className="p-float-label">
                                <Dropdown id="isced" name="isced" value={formik.values.isced && formik.values.isced.value}
                                    options={props?.iscedTypes} onChange={handleIscedChange} optionLabel="translatedLabel"
                                    className={classNames({ 'p-invalid': isFormFieldValid('isced') })} />

                                <label htmlFor="isced" className={classNames({ 'p-error': isFormFieldValid('isced') })}>
                                    {translatedMessage("profile.education.isced")}
                                </label>
                            </span>
                        </div>
                        {getFormErrorMessage('isced')}

                        {/* <div className="p-inputgroup mt-3">
                            <span className="p-float-label">
                                <AutoComplete value={formik.values.domain} suggestions={filteredDomains} completeMethod={searchDomainItems}
                                    virtualScrollerOptions={{ itemSize: 38 }} field="label" dropdown id="domain" name="domain"
                                    onChange={handleDomainChange}
                                    emptyMessage={translatedMessage('generic.tableEmptyMessage')}
                                    className={classNames({ 'p-invalid': isFormFieldValid('domainId') })}
                                    disabled={isDomainDisabled} />

                                <label htmlFor="domain" className={classNames({ 'p-error': isFormFieldValid('domainId') })}>
                                    {translatedMessage("profile.education.domain")}
                                </label>
                            </span>
                        </div>
                        {getFormErrorMessage('domainId')} */}

                        {/* {formik.values.isced?.value && (isDomainDisabled || formik.values.domain?.value === -1) && */}
                            <>
                                <div className="p-inputgroup mt-3">
                                    <span className="p-float-label">
                                        <InputText type="text" name="domainName" id="domainName"
                                            value={formik.values.domainName} onChange={formik.handleChange}
                                            className={classNames({ 'p-invalid': isFormFieldValid('domainName') })} disabled={isDomainNameDisabled}/>
                                        <label htmlFor="domainName" className={classNames({ 'p-error': isFormFieldValid('domainName') })}>
                                            {translatedMessage("profile.education.domainName")} *
                                        </label>
                                    </span>
                                </div>
                                {getFormErrorMessage('domainName')}
                            </>
                        {/* } */}
                    </div>
                </form>
            </Dialog>
        </>
    );
};

export default CompetitionEducationEditDialog;
